
import React from 'react';

interface TourStop {
  title: string;
  description: string;
}

interface TourStopsSectionProps {
  tourStops: TourStop[];
}

const TourStopsSection: React.FC<TourStopsSectionProps> = ({ tourStops }) => {
  return (
    <section className="py-12 bg-[#F5EDE0]">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-8 text-[#3E2723] text-center">
            What You'll Discover
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {tourStops.map((stop, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-[#C58B65]/20">
                <h3 className="font-playfair font-bold text-lg mb-3 text-[#3E2723]">
                  {stop.title}
                </h3>
                <p className="text-[#3E2723]/80 font-montserrat">
                  {stop.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TourStopsSection;
